import React, { useState } from "react";
import { Grid, Card, useTheme, Button, Box, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import HistoricalSignalsControls from "./HistoricalSignalsControls";
import HistoricalSignalsDisplay from "./HistoricalSignalsDisplay";
import { useSignalsState } from "../../hooks/useOptimizedState";
const HistoricalSignalsContent = () => {
  const theme = useTheme();
  const [strategyVal, setStrategyVal] = useState("");
  const [strategyValObj, setStrategyValObj] = useState();

   

  const { strategies, historicalSignalSet, isStrategist } = useSignalsState();

  

  const strategySelected = (id) => {
    if (id === null) {
      setStrategyValObj(undefined);
    } else {
      setStrategyValObj(id);
    }
  };

  const strategyList = strategies
    ?.map((i) => i?.name)
    .sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

  // Function to download CSV
  const downloadCSV = () => {
    if (
      !historicalSignalSet ||
      !historicalSignalSet.signalSets ||
      historicalSignalSet.signalSets.length === 0 ||
      !strategyValObj
    ) {
      return;
    }

    // Filter by selected strategy
    const filteredData = historicalSignalSet.signalSets.filter(
      (signal) => signal.strategy === strategyValObj
    );

    if (filteredData.length === 0) {
      return;
    }

    // Sort by date (newest first)
    const sortedData = filteredData.sort((a, b) => b.date - a.date);

    // Get all unique signal names across all dates
    const allSignalNames = new Set();
    sortedData.forEach((signalSet) => {
      if (signalSet.weights_keys && signalSet.weights_values) {
        Object.keys(signalSet.weights_values).forEach((key) => {
          const tickerInfo = signalSet.weights_keys[key];
          if (tickerInfo && tickerInfo.symbol) {
            allSignalNames.add(tickerInfo.symbol.toUpperCase());
          }
        });
      }
    });
    // Sort signal names alphabetically
    const sortedSignalNames = Array.from(allSignalNames).sort();

    // Create CSV header with signal names and dates
    const csvHeader = [
      "",
      ...sortedData.map((signalSet) => {
        const dateObj = new Date(signalSet.date);
        return `${
          dateObj.getMonth() + 1
        }/${dateObj.getDate()}/${dateObj.getFullYear()}`;
      }),
    ];

    // Create CSV rows with signal names
    const csvRows = [csvHeader];

    sortedSignalNames.forEach((signalName) => {
      const row = [signalName]; // Add signal name as first column

      // Add values for each date
      sortedData.forEach((signalSet) => {
        let value = "";

        // Find the signal in this date's data
        if (signalSet.weights_keys && signalSet.weights_values) {
          Object.keys(signalSet.weights_values).forEach((key) => {
            const tickerInfo = signalSet.weights_keys[key];
            if (
              tickerInfo &&
              tickerInfo.symbol &&
              tickerInfo.symbol.toUpperCase() === signalName
            ) {
              const weight = signalSet.weights_values[key];
              value = (weight * 100).toFixed(4);
            }
          });
        }

        row.push(value);
      });

      csvRows.push(row);
    });

    // Get date range for filename
    const startDate = new Date(sortedData[sortedData.length - 1].date);
    const endDate = new Date(sortedData[0].date);
    const startDateStr = `${
      startDate.getMonth() + 1
    }-${startDate.getDate()}-${startDate.getFullYear()}`;
    const endDateStr = `${
      endDate.getMonth() + 1
    }-${endDate.getDate()}-${endDate.getFullYear()}`;

    // Convert to CSV string
    const csvContent = csvRows
      .map((row) => row.map((cell) => `"${cell}"`).join(","))
      .join("\n");

    // Create and download file
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute(
      "download",
      `historical_signals_${strategyVal}_${startDateStr}-${endDateStr}.csv`
    );
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Check if there's data to download
  const hasData =
    historicalSignalSet &&
    historicalSignalSet.signalSets &&
    historicalSignalSet.signalSets.length > 0 &&
    strategyValObj &&
    historicalSignalSet.signalSets.some((signal) => signal.strategy === strategyValObj);

  return (
    <Grid container spacing={3}>
      {/* Controls Section */}
      <Grid item xs={12}>
        <Card
          sx={{
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: `1px solid ${theme.palette.divider}`,
            p: 3,
          }}
        >
          <HistoricalSignalsControls
            strategyList={strategyList}
            strategyVal={strategyVal}
            setStrategyVal={setStrategyVal}
            strategyValObj={strategyValObj}
            strategySelected={strategySelected}
            strategies={strategies}
            isStrategist={isStrategist}
          />
        </Card>
      </Grid>

      {/* Display Section */}
      <Grid item xs={12}>
        <Card
          sx={{
            borderRadius: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            border: `1px solid ${theme.palette.divider}`,
            
            p: 3,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <HistoricalSignalsDisplay
                strategies={strategies}
                strategyValObj={strategyValObj}
                strategyVal={strategyVal}
                isStrategist={isStrategist}
                historicalSignalSet={historicalSignalSet}
                onDownload={downloadCSV}
                hasData={hasData}
              />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default HistoricalSignalsContent;
